var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.47 19.409a.75.75 0 1 0 1.06 1.06L20.44 4.56a.75.75 0 0 0-1.06-1.06l-2.86 2.86A9.7 9.7 0 0 0 12 5.249c-4.641 0-8.523 3.243-9.509 7.585a.75.75 0 0 0 1.463.332A8.253 8.253 0 0 1 15.398 7.48l-2.6 2.6a4 4 0 0 0-4.72 4.72zm8.53-1.41c-.85 0-1.637-.264-2.284-.715l5.568-5.568A4 4 0 0 1 12 18m8.045-4.833a8.23 8.23 0 0 0-2.212-4l1.061-1.06a9.74 9.74 0 0 1 2.614 4.728.75.75 0 1 1-1.463.332",
    clipRule: "evenodd"
  })));
};
export default SvgEyeClosed;